import { CustomerTotalValuesReportViewModel } from '@dynamik/common/clients/reporting-clients';
import { CustomerService, IApplicationFilter, PortfolioReportCache, property, widget } from '@dynamik/common';
import { BindingEngine, customElement } from 'aurelia-framework';
import { WidgetBase } from '@dynamik/common';
import { addMonths, format } from '../../../date-fns-local';

@customElement('customer-totals-widget')
@widget('Customer totals', true, true, 'Description')
export class CustomerTotalsWidget extends WidgetBase {
  constructor(element: Element, customerService: CustomerService, private portfolioReportCache: PortfolioReportCache, bindingEngine: BindingEngine) {
    super(element, bindingEngine, customerService);
  }

  totals: CustomerTotalValuesReportViewModel;
  totalsLM: CustomerTotalValuesReportViewModel;
  navChangeYTD: number;
  navChangeYTDLM?: number;
  osebxChangeYTD: number;
  osebxChangeYTDLM?: number;
  navChangeLM: number;
  osebxChangeLM?: number;
  noGL: boolean;

  @property('Data', 'Value LM')
  showValueLM: boolean = true;

  @property('Data', 'Value YTD')
  showValueYTD: boolean = true;

  @property('Data', 'showNav')
  showNav: boolean = true;

  @property('Data', 'NAV Δ LM')
  showNavChangeLM: boolean;

  @property('Data', 'NAV Δ YTD')
  showNavChangeYTD: boolean;

  @property('Data', 'NAV Δ YTD LM')
  showNavChangeYTDLM: boolean;

  @property('Data', 'NAV per Share')
  showNavPerShare: boolean = true;

  @property('Data', 'OSEBX Δ LM')
  showOsebxChangeLM: boolean;

  @property('Data', 'OSEBX Δ YTD')
  showOsebxChangeYTD: boolean;

  @property('Data', 'OSEBX Δ YTD LM')
  showOsebxChangeYTDLM: boolean;

  @property('Data', 'Profit LM')
  showProfitLM: boolean = true;

  @property('Data', 'Profit YTD')
  showProfitYTD: boolean = true;

  @property('Table')
  font?: string;

  @property('Table')
  fontSize?: number = 25;

  @property('Table')
  color?: string;

  @property()
  captionFont?: string;

  @property()
  captionFontSize?: number = 12;

  @property()
  captionColor?: string;


  override async loadData(filter: IApplicationFilter) {
    return this.portfolioReportCache.customerTotals(filter.customer.companyId, undefined, filter.dates.toStr, undefined, false);
  }

  override async setData(data: CustomerTotalValuesReportViewModel[]) {
    this.totals = data[data.length - 1];
    this.noGL = !this.totals.netAssetValueClosingBalance;
    this.navChangeYTD = this.totals.netAssetValueAdjusted - this.totals.netAssetValueEndOfLastYearAdjusted;
    this.osebxChangeYTD = this.totals.indexSellpriceClosingBalance - this.totals.indexSellPriceEndOfLastYear;
    const date = this.customerService.selectedDates.to;
    if (date.getMonth() > 0) {
      this.totalsLM = data.find(x => x.dateClosingBalance === format(addMonths(date, -1), 'yyyy-MM-dd\'T\'00:00:00\'Z\''));
      this.navChangeYTDLM = this.totalsLM.netAssetValueAdjusted - this.totalsLM.netAssetValueEndOfLastYearAdjusted;
      this.osebxChangeYTDLM = this.totalsLM.indexSellpriceClosingBalance - this.totalsLM.indexSellPriceEndOfLastYear;
      this.navChangeLM = this.navChangeYTD - this.navChangeYTDLM;
      this.osebxChangeLM = this.osebxChangeYTD - this.osebxChangeYTDLM;
    } else {
      this.navChangeYTDLM = 0;
      this.osebxChangeYTDLM = 0;
      this.navChangeLM = 0;
      this.osebxChangeLM = 0;
    }
    this.excelData = {
      fileName: 'Customer Totals',
      data: { Items: data }
    };
  }
}
